<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="search-wrapper">
         <el-button :type="queryParam.type == 0 ? 'primary' : 'plain'" @click="clickTypeButton(0)">全部</el-button>
         <el-button :type="queryParam.type == 1 ? 'primary' : 'plain'" @click="clickTypeButton(1)">
            {{ '未关联学校' + (queryParam.type == 1 && unassociatedCount ? unassociatedCount : '') }}
         </el-button>
         <el-form class="margin-left-20" inline :model="queryParam">
            <el-form-item label="校区名称" v-if="queryParam.type != 1">
               <el-select v-model="queryParam.schoolId" placeholder="请选择校区" filterable clearable>
                  <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.rootUnid">
                  </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="设备UID">
               <el-input placeholder="请输入设备UID" clearable :maxlength="100" v-model="queryParam.uid"></el-input>
            </el-form-item>
            <el-form-item label="信息同步进度">
               <el-select v-model="queryParam.synSchedule">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="处理中" value="0"></el-option>
                  <el-option label="已完成" value="1"></el-option>
               </el-select>
            </el-form-item>
            <el-form-item>
               <el-button type="primary" @click="clickQuery">搜索</el-button>
               <el-button @click="clickReset">重置</el-button>
            </el-form-item>
         </el-form>
      </div>

      <div class="content-wrapper">
         <el-table :data="tableData" border style="width: 100%;">
            <el-table-column align="center" label="序号" width="80" type="index"></el-table-column>
            <el-table-column align="center" label="设备ID" prop="onePcId"> </el-table-column>
            <el-table-column align="center" label="关联学校" prop="schoolName"></el-table-column>
            <el-table-column align="center" label="激活时间" inline-template>
               <span>{{ row.activeTime ? $util.dateFormat(new Date(row.activeTime)) : '' }}</span>
            </el-table-column>
            <el-table-column align="center" label="学生信息同步进度" inline-template>
               <span>{{ handleSynSchedule(row) }}</span>
            </el-table-column>
            <el-table-column align="center" label="操作" width="280" inline-template>
               <span>
                  <el-button type="text" size="small" v-if="!row.schoolId || row.schoolId === ''"
                     @click="clickBinding(row)">
                     绑定学校
                  </el-button>
                  <el-button type="text" size="small" @click="clickDelete(row)">删除设备</el-button>
               </span>
            </el-table-column>
         </el-table>

         <div class="pagination-wrapper">
            <el-pagination v-show="total > 0" layout="prev, pager, next" :current-page="queryParam.pageNum"
               :page-size='queryParam.pageSize' :total="total" @current-change="changeCurrentPage">
            </el-pagination>
         </div>
      </div>

      <el-dialog custom-class="dialog-wrapper" title="绑定学校" v-model="bindingDialog.visible"
         :close-on-click-modal="false" :modal-append-to-body="true" ref="bindingDialogRef" :modal="false">
         <el-form label-width="80px">
            <el-form-item label="选择学校">
               <el-select v-model="bindingDialog.schoolId" placeholder="请选择学校" filterable style="width: 100%;">
                  <el-option v-for="(item, index) in bindingDialog.schoolOptions" :key="index" :label="item.label"
                     :value="item.value">
                  </el-option>
               </el-select>
            </el-form-item>
         </el-form>
         <template #footer>
            <div class="flex-row-center">
               <el-button @click="bindingDialog.visible = false">取消</el-button>
               <el-button type="primary" @click="clickBindingDone">确定</el-button>
            </div>
         </template>
      </el-dialog>
   </div>
</template>

<script>
export default {
   data() {
      return {
         loading: false,
         queryParam: {
            type: 0,
            schoolId: '',
            uid: '',
            synSchedule: '',
            pageNum: 1,
            pageSize: 10,
         },
         unassociatedCount: 0,
         schoolList: [],
         tableData: [],
         total: 0,
         bindingDialog: {
            visible: false,
            uid: '',
            schoolOptions: [],
            schoolId: '',
         }
      }
   },

   mounted() {
      this.queryAllSchool();
   },

   methods: {
      // 获取所有学校
      queryAllSchool() {
         this.loading = true;
         this.$http({
            method: "get",
            url: this.$util.domain + "/adminapi/v1/basicTools/schoolList",
         }).then((response) => {
            if (response.data.error == 10000) {
               this.schoolList = response.data.data;
               if (this.schoolList.length > 0) {
                  let item = this.schoolList[this.schoolList.length - 1];
                  this.queryParam.schoolId = item.rootUnid;
                  this.queryList();
               }
            } else {
               this.$util.errorMsg(response.data.message);
            }
         }).finally(() => {
            this.loading = false;
         });
      },

      // 查询体检一体机列表
      queryList() {
         this.loading = true;
         let param = { ...this.queryParam };
         if (this.queryParam.type == 1) {
            param.schoolId = '';
         }
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/exam/onePc/v300/listPage',
            params: param,
            headers: { channelCode: 'iydsj' },
         }).then((result) => {
            if (!result.data.data || JSON.stringify(result.data.data) === '{}') {
               this.total = 0;
               this.tableData = [];
               return;
            }
            this.total = result.data.data.total || 0;
            this.tableData = result.data.data.content || [];
         }).catch(() => {
            this.total = 0;
            this.tableData = [];
         }).finally(() => {
            this.loading = false;
         });
      },

      // 绑定学校
      queryBindingSchool() {
         this.loading = true
         let param = {
            schoolId: this.bindingDialog.schoolId,
            uid: this.bindingDialog.uid
         }
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/exam/onePc/v300/bind',
            params: param,
            headers: { channelCode: 'iydsj' },
         }).then((res) => {
            if (res.data.data) {
               this.bindingDialog.visible = false;
               this.queryList();
               this.$util.successMsg(res.data.msg);
            } else {
               this.$util.errorMsg(res.data.msg);
            }
         }).catch((err) => {
            this.$util.errorMsg(err.msg);
         }).finally(() => {
            this.loading = false;
         })
      },

      // 删除设备
      queryDelete(uid) {
         this.loading = true;
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/exam/onePc/v300/delete',
            params: { uid },
            headers: { channelCode: 'iydsj' },
         }).then((res) => {
            if (res.data) {
               this.queryList();
            }
            this.$util.successMsg(res.msg);
         }).catch((err) => {
            this.$util.errorMsg(err.msg);
         }).finally(() => {
            this.loading = false;
         })
      },

      // 点击类型按钮
      clickTypeButton(type) {
         if (this.queryParam.type == type) {
            return;
         }
         this.queryParam.type = type;
         this.queryList();
      },

      // 点击查询
      clickQuery() {
         this.queryList();
      },

      // 点击重置
      clickReset() {
         this.queryParam = {
            type: 0,
            schoolId: '',
            uid: '',
            synSchedule: '',
            pageNum: 1,
            pageSize: 20,
         };
         if (this.schoolList.length > 0) {
            let item = this.schoolList[this.schoolList.length - 1];
            this.queryParam.schoolId = item.rootUnid;
         }
         this.queryList();
      },

      // 点击绑定学校
      clickBinding(row) {
         this.bindingDialog.schoolOptions = this.schoolList.map((item) => ({
            label: item.name,
            value: item.rootUnid,
         }))
         this.bindingDialog.uid = row.uid;
         this.bindingDialog.schoolId = row.schoolId || this.bindingDialog.schoolOptions[0].value || '';
         this.bindingDialog.visible = true;
      },

      // 点击绑定学校确认
      clickBindingDone() {
         this.$confirm('绑定后即将同步学校学生数据到设备', '温馨提示', {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: 'warning'
         }).then(() => {
            this.queryBindingSchool();
         }).catch(() => { });
      },

      // 点击删除设备
      clickDelete(row) {
         this.$confirm('是否确认删除该台设备', '温馨提示', {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: 'warning'
         }).then(() => {
            this.queryDelete(row.uid);
         }).catch(() => { });
      },

      // 切换页码
      changeCurrentPage(value) {
         this.queryParam.pageNum = value;
         this.queryList();
      },

      // 处理学生信息同步进度（0.处理中；1.已完成）
      handleSynSchedule(row) {
         if (!row.schoolId) {
            return '--'
         }
         if (row.synSchedule == null || row.synSchedule == undefined) {
            return '--'
         } else if (row.synSchedule == 0) {
            return '处理中'
         } else if (row.synSchedule == 1) {
            return '已完成'
         }
         return ''
      }
   }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// EquipmentPhysical.vue?39063153